import { render, staticRenderFns } from "./webscoket.vue?vue&type=template&id=1996ad9c&"
import script from "./webscoket.vue?vue&type=script&lang=js&"
export * from "./webscoket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports